/** Bridges API-driven session activity to react-idle-timer `reset()` (hook registers here). */
let resetFn: (() => void) | null = null

let suppressResetFn: () => boolean = () => false

export function registerIdleTimerReset(fn: (() => void) | null): void {
  resetFn = fn
}

export function registerIdleTimerResetSuppression(
  fn: (() => boolean) | null
): void {
  suppressResetFn = fn ?? (() => false)
}

export function resetIdleTimerFromExternalActivity(): void {
  if (suppressResetFn()) return
  resetFn?.()
}

export function forceResetIdleTimerFromExternalActivity(): void {
  resetFn?.()
}
